var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5574 9.54615C22.3967 9.67217 19.5596 11.2879 19.5596 14.8807C19.5596 19.0363 23.1697 20.5065 23.2777 20.5429C23.2611 20.6325 22.7042 22.5563 21.3743 24.5165C20.1885 26.2414 18.95 27.9636 17.066 27.9636C15.182 27.9636 14.6971 26.8575 12.5222 26.8575C10.4027 26.8575 9.64908 28 7.92576 28C6.20244 28 4.99999 26.4038 3.61746 24.4436C2.01604 22.1418 0.722168 18.5659 0.722168 15.1719C0.722168 9.72817 4.22422 6.84108 7.67086 6.84108C9.50224 6.84108 11.0288 8.05641 12.1786 8.05641C13.273 8.05641 14.9797 6.76828 17.0632 6.76828C17.8529 6.76828 20.69 6.84108 22.5574 9.54615ZM16.0741 4.46365C16.9358 3.43034 17.5453 1.9966 17.5453 0.562856C17.5453 0.364036 17.5287 0.162416 17.4927 0C16.0908 0.0532053 14.4228 0.943695 13.4171 2.12261C12.6275 3.0299 11.8905 4.46365 11.8905 5.91699C11.8905 6.13541 11.9265 6.35384 11.9431 6.42384C12.0318 6.44064 12.1759 6.46025 12.32 6.46025C13.5778 6.46025 15.1598 5.60896 16.0741 4.46365Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/AppleIcon.9f3cdb802b7b4c79ac5ffb29bbab0916.svg";
export { ForwardRef as ReactComponent };